import { NormalizedVoucher, FeatureAppStepCitaMode } from '@esportal/portal-service';
import {
	Container,
	ContainerPadding,
	CTA,
	Text,
	styled,
	TextAlignment,
	ContainerGutter,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import { useTrackingManager } from '../../../tracking/use-tracking-manager';

const CTAFullCtr = styled.div`
	/* & > a {
    padding: 0;
  } */
`;

interface CategoryCTA {
	tag: 'button' | 'a';
	href?: string;
	onClick?: any;
	text: string;
}

interface Props {
	voucher: NormalizedVoucher;
	handleClickRequestAppointment: (mode: FeatureAppStepCitaMode) => void;
}

export const SalesforceVouchersDetailCtas: React.FC<Props> = ({ voucher }) => {
	const trackingManager = useTrackingManager();

	const categoryDefaultCTA: {
		primary: CategoryCTA;
	} = {
		primary: {
			tag: 'a',
			href: 'https://www.volkswagen.es/es/vive-volkswagen.html',
			text: 'Vive Volkswagen',
			onClick: () => {
				trackingManager.trackClubVWButtonClick(`Vive Volkswagen - Voucher - ${voucher.card.title}`, {
					contentId: `Vive Volkswagen - Voucher - ${voucher.card.title}`,
					sectionName: 'vouchers-detail-lives',
				});
			},
		},
	};

	const categoryCTA: {
		primary: CategoryCTA;
		secondary?: CategoryCTA;
	} | null =
		voucher.source === 'salesforce' && voucher.card.cta?.src == null
			? null
			: voucher.source === 'salesforce' && voucher.card.cta?.src != null
				? {
						primary: {
							tag: 'a',
							href: voucher.card.cta.src,
							text: voucher.card.cta.label || '',
							onClick: () => {
								trackingManager.trackClubVWButtonClick(`Voucher Salesforce - Campaign: ${voucher.campaign} - ${voucher.card.cta?.label}`, {
									contentId: `Voucher Salesforce - Campaign: ${voucher.campaign} - ${voucher.card.cta?.label}`,
									sectionName: 'voucher-salesforce-detail',
								});
							},
						},
					}
				: categoryDefaultCTA;

	const renderCTA = (cta: CategoryCTA, stretchContent = false) =>
		cta.tag === 'a' ? (
			<CTA
				tag="a"
				href={cta.href}
				target="_blank"
				onClick={cta.onClick}
				emphasis={'nbab' as any}
				stretchContent={stretchContent}
			>
				{cta.text}
			</CTA>
		) : (
			<CTA tag="button" onClick={cta.onClick} emphasis={'nbab' as any}>
				{cta.text}
			</CTA>
		);

	return (
		<div>
			{categoryCTA ? (
				<Container
					wrap="always"
					stretchContent
					horizontalAlign="center"
					gutter={ContainerGutter.dynamic0100}
					padding={{ bottom: ContainerPadding.dynamic0130, top: ContainerPadding.dynamic0130 }}
				>
					<Container horizontalAlign="center" stretchContent>
						<Text textAlign={TextAlignment.center}>
							<CTAFullCtr>{renderCTA(categoryCTA.primary)}</CTAFullCtr>
						</Text>
					</Container>

					{categoryCTA.secondary && (
						<Text textAlign={TextAlignment.center}>
							<CTAFullCtr>{renderCTA(categoryCTA.secondary, true)}</CTAFullCtr>
						</Text>
					)}
				</Container>
			) : (
				<Container padding={{ bottom: ContainerPadding.dynamic0130 }}>
					<div />
				</Container>
			)}
		</div>
	);
};
